import { createFileRoute } from "@tanstack/react-router";
import { BookPage } from "@/features/bookpublic/BookPage";

/** Public booking page for one meeting type, by its slug. Sits outside the _app layout, so there is no app shell. */
export const Route = createFileRoute("/p/book/$slug")({
  component: BookRoute,
});

function BookRoute() {
  const { slug } = Route.useParams();
  return <BookPage slug={slug} />;
}
